import { render, staticRenderFns } from "./FeedStatus.vue?vue&type=template&id=191f32b8&"
import script from "./FeedStatus.vue?vue&type=script&lang=js&"
export * from "./FeedStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports